// extracted by mini-css-extract-plugin
export var container = "banner-module--container--Oek2Y";
export var item = "banner-module--item--bzUJJ";